import { render } from "./ModalDetalle.vue?vue&type=template&id=59bb7e7d&scoped=true"
import script from "./ModalDetalle.vue?vue&type=script&lang=js"
export * from "./ModalDetalle.vue?vue&type=script&lang=js"

import "./ModalDetalle.vue?vue&type=style&index=0&id=59bb7e7d&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bb7e7d"]])

export default __exports__